module.exports = __webpack_public_path__ + "img/8.10ad6c06.gif";